import { format } from '@/helpers/money.js';

export default function (value) {
  return format(value || 0);
};
